$(document).on('turbolinks:load', function () {
  if (!$('body').hasClass('controller-public-hotsites-round-scores')) return;

  const changeOffLabel = (elem, value) => {
    const label = elem.parent().find('.bootstrap-switch-label');
    label.text(value ? 'NET' : 'GROSS');
  };

  $('.hotsite-round-scores-filters select').on('change', function () {
    $(this).closest('form').trigger('submit');
  });

  $('input.switch-input').hide();
  setTimeout(function () {
    $('input.switch-input').each(function () {
      const target = this;
      $(this).bootstrapSwitch('state', $(this).attr('checked'));
      $(this).on('switchChange.bootstrapSwitch', function (_event, state) {
        $('#report_type_input').val(state ? 'gross' : 'net');
        changeOffLabel($(target), state);
        $(target).closest('form').trigger('submit');
      });
      changeOffLabel($(target), $('#report_type_input').val() === 'gross');
    });
  }, 300);
});
